import { Link } from "react-router-dom";

export default function CoreFeatures(){
    return(
        <section class="core-feature-area core-bg pt-120 pt-md-60 pt-xs-120 pb-30 pb-md-30 pb-xs-30">
			<div class="container">
				<div class="row">
					<div class="col-lg-12">
						<div class="section-title text-center mb-55">
							<p class="lh-1 mb-10">Core Features</p>
							<h2 class="sect-title text-heding3">Company work process</h2>
						</div>
					</div>
				</div>
				<div class="row gx-0">
					<div class="col-lg-4 col-md-4">
						<div class="core-feature text-center mb-30">
							<div class="core-content">
								<h4>Legendary</h4>
								<h3>Support</h3>
								<p>Offering Smart Insurance Investment
									Solutions to Companies</p>
								<img src="assets/img/icon/f-2a.png" alt="F-icon" />
							</div>
							<Link to="/services-details" class="read-more">Learn More <i class="fal fa-long-arrow-right"></i></Link>
						</div>
					</div>
					<div class="col-lg-4 col-md-4">
						<div class="core-feature text-center mb-30">
							<div class="core-content">
								<h4>Get Your</h4>
								<h3>Clarifications</h3>
								<p>Offering Smart Insurance Investment
									Solutions to Companies</p>
								<img src="assets/img/icon/f-2b.png" alt="F-icon" />
							</div>
							<Link to="/services-details" class="read-more">Learn More <i class="fal fa-long-arrow-right"></i></Link>
						</div>
					</div>
					<div class="col-lg-4 col-md-4">
						<div class="core-feature text-center mb-30">
							<div class="core-content">
								<h4>Maintenance</h4>
								<h3>Package</h3>
								<p>Offering Smart Insurance Investment
									Solutions to Companies</p>
								<img src="assets/img/icon/f-2c.png" alt="F-icon" />
							</div>
							<Link to="/services-details" class="read-more">Learn More <i class="fal fa-long-arrow-right"></i></Link>
						</div>
					</div>
				</div>
			</div>
		</section>
    )
}